import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQuery } from "@tanstack/react-query";
import listAxpoSiteNameMappings from "../http/listAxpoSiteNameMappings";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const useAxpoSiteNameMappings = () => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  return useQuery(["axpo-site-name-mappings"], async () =>
    listAxpoSiteNameMappings(await getAuthTokenBlocking(getToken, relogin))
  );
};

export default useAxpoSiteNameMappings;
